module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('h1', {
    staticClass: "Titlepg1"
  }, [_vm._v("Moon Milk")]), _vm._v(" "), _c('h2', {
    staticClass: "Titlepg2"
  }, [_vm._v("Easy Recipes for peaceful sleep")]), _vm._v(" "), _c('div', {
    staticClass: "rule"
  }), _vm._v(" "), _c('h3', {
    staticClass: "Titlepg3"
  }, [_vm._v("Anni Daulter")]), _vm._v(" "), _c('p', {
    staticClass: "Titlepg4"
  }, [_vm._v("with Jessica Booth and Alexis Donahue")]), _vm._v(" "), _c('p', {
    staticClass: "Titlepg5"
  }, [_vm._v("Photographs by"), _c('em', {
    staticClass: "Emphasis CharOverride-1"
  }), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Megan Elizondo ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "small",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1 logo",
    attrs: {
      "alt": "logo",
      "src": "image/logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "full",
    attrs: {
      "alt": "Slumber shots in stemmed glasses with a rose.",
      "src": "image/night_owl-slumber_shots.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("Text © 2020 Anni Daulter")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Photographs © 2020 Megan Elizondo")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("Contributing writers Jessica Booth and Alexis Donahue")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright ParaOverride-1"
  }, [_vm._v("Names: Daulter, Anni, author. | Elizondo, Megan, photographer.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Title: Moon milk : easy recipes for peaceful sleep / Anni Daulter ; photographs by Megan Elizondo.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Description: First edition. | Layton : Gibbs Smith, [2020] | ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Identifiers: LCCN 2019036072 | ISBN 9781423654483 (hardcover) | ISBN 9781423654490 (epub)  ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Subjects: LCSH: Beverages. | LCGFT: Cookbooks. ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Classification: LCC TX815 .D24 2020 | DDC 641.2—dc23 ")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("LC record available at https://lccn.loc.gov/2019036072")])]), _vm._v(" "), _c('div', {
    staticClass: "forespace linen",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('div', {
    staticClass: "rule helf"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Dedication"
  }, [_vm._v("To our families and friends who supported and loved our moonalicious vision!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "full",
    attrs: {
      "alt": "Photo of Sleeping Beauty in various shades of blue and purple.",
      "src": "image/starlit_soother-sleeping_beauty_v2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d23066c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Moon_Milk_Digital.vue
// module id = 60
// module chunks = 0